import React from 'react'
import css from './style.scss'
import api from './api'
import store from 'utils/store'
import Formsy from 'formsy-react-2';
import Input from 'components/shared/input'
import Button from 'components/shared/button'
import Cookies from 'js-cookie'
import analytics from 'utils/analytics'
import moment from 'moment-timezone'
import Select from 'components/shared/input/select'
import {push} from 'react-router-redux'
class DataSection extends React.Component{
  submit=(model)=>{
    api.updateUser(model)
  }

  logout=()=>{
    analytics.track("logout")
    Cookies.remove('stories_session')
    store.dispatch(push("/"))
    store.dispatch({type:"LOGOUT"})
  }

  render(){
    const options = moment.tz.names().map(n=>{return {value:n, label:n}})
    return (
      <div className={css.data_section}>
        <Formsy.Form onValidSubmit={this.submit}>
          <Input type="text" fullWidth={true} required label="First Name" name="firstName" value={this.props.user.firstName}/>
          <Input type="text" fullWidth={true} required label="Last Name" name="lastName" value={this.props.user.lastName}/>
          <Input type="email" fullWidth={true} required validations="isEmail" label="Your Email" name="email" value={this.props.user.email}/>
          <Select fullWidth={true} label="Your Timezone" name="timezone" options={options} value={this.props.user.timezone}/>
          <Select fullWidth={true} label="Monday Email Report" name="settings.weeklyDigest" options={[{value:true, label:"Yes"}, {value:false, label:"No"}]} value={this.props.user.settings.weeklyDigest}/>
          <Button primary type="submit">Save</Button>
        </Formsy.Form>
        <hr/>
        <button onClick={this.logout}>Logout from this account</button>
      </div>
    )
  }
}

export default DataSection;



// WEBPACK FOOTER //
// ./src/components/settings/data_section.js